import fetch from 'utils/fetch'
/*
creatMsg api
*/
export function getUserList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}`,
    method: 'post',
    data
  })
}
export function sendMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/create/sendMessage`,
    method: 'post',
    data
  })
}
export function createDraftMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/draft/createDraftMessage`,
    method: 'post',
    data
  })
}
export function getDraftMsgInfo (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/detail/getDraftMessageDetail`,
    method: 'post',
    data
  })
}
export function getMsgInfo (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/detail/getMessageDetail`,
    method: 'post',
    data
  })
}

/*
receiptMsg api
*/
export function getReceiptMsgList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxTopicList`,
    method: 'post',
    data
  })
}
export function getReceiptTopicCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxTopicTotalCount`,
    method: 'post',
    data
  })
}
export function getReceiptMsgCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxListTotalCount`,
    method: 'post',
    data
  })
}
export function getReceiptMsgUnreadCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxListTotalUnreadCount`,
    method: 'post',
    data
  })
}
export function getReceiptMsgListSearch (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/autoFuzzySearchInboxMessageInfoList`,
    method: 'post',
    data
  })
}
export function getReceiptMsgListSearchCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/autoFuzzySearchInboxMessageInfoListCount`,
    method: 'post',
    data
  })
}
export function getReceiptMsgDetailList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxInfoListWithTextUnderTopic`,
    method: 'post',
    data
  })
}
export function replyReceiptMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/create/replyMessage`,
    method: 'post',
    data
  })
}
export function createReceiptDraftMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/draft/createDraftReply`,
    method: 'post',
    data
  })
}

/*
sendMsg api
*/
export function getSendMsgList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/outbox/getOutboxTopicList`,
    method: 'post',
    data
  })
}
export function getSendMsgCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/outbox/getOutboxMessageInfoTotalCount`,
    method: 'post',
    data
  })
}
export function getSendMsgListSearch (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/autoFuzzySearchOutboxMessageInfoList`,
    method: 'post',
    data
  })
}
export function getSendMsgListSearchCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/autoFuzzySearchOutboxMessageInfoListCount`,
    method: 'post',
    data
  })
}
export function getSendMsgDetailList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/outbox/getOutboxInfoListWithTextUnderTopic`,
    method: 'post',
    data
  })
}
export function replySendMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/create/replyMessage`,
    method: 'post',
    data
  })
}
export function createSendDraftMsg (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/draft/createDraftReply`,
    method: 'post',
    data
  })
}

/*
draftsMsg api
*/
export function getDraftsList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/draft/getDraftList`,
    method: 'post',
    data
  })
}
export function getDraftsCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/inbox/getInboxListTotalCount`,
    method: 'post',
    data
  })
}
export function deleteDrafts (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/draft/deleteDrafts`,
    method: 'post',
    data
  })
}

/*
systemMsg api
*/
export function getSystemMsgList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/system/getSystemMessageDetailList`,
    method: 'post',
    data
  })
}
export function getSystemMsgCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/system/getSystemMessageListCount`,
    method: 'post',
    data
  })
}
export function getRead (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/readMessage`,
    method: 'post',
    data
  })
}

/*
searchMsg api
*/
export function getMsgList (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/fuzzySearchMessageInfoAndDetailList`,
    method: 'post',
    data
  })
}
export function getMsgCount (data) {
  return fetch({
    url: `${process.env.MESSAGE_API}/message/search/fuzzySearchMessageInfoCount`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/message.js